<template>
    <div class="vx-card p-6">
        <div class="vx-row">
            <div class="vx-col w-full">
                <h3 class="text-primary">Thông tin Phiếu thu</h3>
            </div>
        </div>
        <div class="vx-row mt-4">
            <div class="vx-col md:w-1/4 w-full mt-2">
                <label class="vs-input--label required">{{ $t('invoice.dueDate') }}</label>
                <datepicker class="w-full" :highlighted="highlighted"
                            :language="vi" :format="'dd/MM/yyyy'" v-model="receiptsInfo.dueDate"
                            data-vv-validate-on="input" v-validate="'required'" name="dueDate" :disabled="isUpdate"
                            @input="selectDate">
                </datepicker>
                <span class="text-danger text-sm">{{ errors.first('dueDate') }}</span>
            </div>
            <div class="vx-col md:w-1/4 w-full mt-2">
                <label class="vs-input--label required">{{ $t('invoice.paymentDate') }}</label>
                <datepicker class="w-full" :highlighted="highlighted" :disabledDates="disabledFn"
                            :language="vi" :format="'dd/MM/yyyy'" v-model="receiptsInfo.paymentDate"
                            data-vv-validate-on="input" v-validate="'required'" name="paymentDate" @input="selectDate">
                </datepicker>
                <span class="text-danger text-sm">{{ errors.first('paymentDate') }}</span>
            </div>
            <div class="vx-col md:w-1/4 w-full mt-2">
                <label class="vs-input--label required">{{ $t('invoice.type') }}</label>
                <v-select class="w-full" v-model="receiptsInfo.type" :options="typeOptions"
                          :reduce="(option) => option.value" :clearable="false" v-validate="'required'"
                          name="typeInvoice" :disabled="isUpdate" @input="changeType">
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('typeInvoice') }}</span>
            </div>
            <div class="vx-col md:w-1/4 w-full mt-2">
                <label class="vs-input--label required">{{ $t('invoice.school') }}</label>
                <v-select class="w-full" v-model="receiptsInfo.organizationBranchId" :options="branchOptions"
                          :disabled="!Number.isInteger(receiptsInfo.type) || isUpdate" :clearable="false"
                          :reduce="(option) => option.value" v-validate="'required'" name="school"
                          @input="changeType">
                    <span slot="no-options">{{ $t('root.noRowsToShow') }}</span>
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('school') }}</span>
            </div>
        </div>
        <div class="vx-row mt-2">
            <div class="vx-col md:w-1/3 w-full mt-2"
                 v-if="receiptsInfo.type === 0 && receiptsInfo.organizationBranchId">
                <label class="vs-input--label required">{{ $t('invoice.class') }}</label>
                <v-select class="w-full" v-model="receiptsInfo.classId" :options="classOptions" :disabled="isUpdate"
                          :reduce="(option) => option.value" :clearable="false" v-validate="'required'" name="class"
                          @input="changeClass">
                    <span slot="no-options">{{ $t('root.noRowsToShow') }}</span>
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('class') }}</span>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-2"
                 v-if="(!isUpdate && receiptsInfo.type === 0 && receiptsInfo.classId) || (isUpdate && receiptsInfo.studentId)">
                <label class="vs-input--label">{{ $t('invoice.student') }}</label>
                <v-select class="w-full" v-model="receiptsInfo.studentId" :options="studentOptions"
                          :reduce="(option) => option.value"
                          name="student" :disabled="isUpdate">
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('student') }}</span>
            </div>
        </div>
        <vs-divider/>
        <div class="vx-row my-6">
            <div class="vx-col w-full">
                <vs-table stripe hoverFlat :data="listDetails" noDataText="">
                    <template slot="header">
                        <h3>
                            Chi tiết
                        </h3>
                    </template>
                    <template slot="thead">
                        <vs-th>
                            {{ $t('invoice.index') }}
                        </vs-th>
                        <vs-th>
                            {{ $t('invoice.product') }}
                        </vs-th>
                        <vs-th>
                            {{ $t('invoice.unit') }}
                        </vs-th>
                        <vs-th>
                            {{ $t('invoice.unitPrice') }}
                        </vs-th>
                        <vs-th>
                            {{ $t('invoice.quantity') }}
                        </vs-th>
                        <vs-th>
                            {{ $t('invoice.amount') }}
                        </vs-th>
                        <vs-th>
                        </vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>
                                {{ indextr + 1 }}
                            </vs-td>
                            <vs-td>
                                <vs-input v-model="tr.product" :danger="!tr.product"
                                          :danger-text="$t('invoice.validateProduct')"></vs-input>
                            </vs-td>
                            <vs-td>
                                <vs-input v-model="tr.unit" :danger="!tr.unit"
                                          :danger-text="$t('invoice.validateUnit')"></vs-input>
                            </vs-td>
                            <vs-td>
                                <vs-input v-model="tr.unitPrice" :danger="!tr.unitPrice || isNaN(tr.unitPrice)"
                                          :danger-text="!tr.unitPrice ? $t('invoice.validateUnitPrice') : $t('invoice.numericUnitPrice')"
                                          @input="charge(tr)"></vs-input>
                                <span class="text-danger text-sm">{{ errors.first('unitPrice') }}</span>
                            </vs-td>
                            <vs-td>
                                <vs-input v-model="tr.quantity" :danger="!tr.quantity || isNaN(tr.quantity)"
                                          :danger-text="!tr.quantity ? $t('invoice.validateQuantity') : $t('invoice.numericQuantity')"
                                          @input="charge(tr)"></vs-input>
                                <span class="text-danger text-sm">{{ errors.first('quantity') }}</span>
                            </vs-td>
                            <vs-td>
                                <vs-input v-model="tr.amount" readonly></vs-input>
                            </vs-td>
                            <vs-td>
                                <div class="flex mt-2">
                                    <vx-tooltip class="position-icon" :text="$t('button.add')" position="top"
                                                v-if="indextr === (data.length - 1)">
                                        <feather-icon icon="PlusCircleIcon" class="text-primary mr-2"
                                                      svgClasses="h-5 w-5 cursor-pointer"
                                                      @click="addRecord()"/>
                                    </vx-tooltip>
                                    <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top"
                                                v-if="data.length > 1">
                                        <feather-icon icon="XCircleIcon" class="text-danger"
                                                      svgClasses="h-5 w-5 cursor-pointer"
                                                      @click="confirmDeleteRecord(indextr)"/>
                                    </vx-tooltip>
                                </div>
                            </vs-td>
                        </vs-tr>
                        <vs-tr>
                            <vs-td colspan="5">
                                <h5>Giảm trừ</h5>
                            </vs-td>
                            <vs-td>
                                <vs-input v-model="receiptsInfo.deduction" @input="chargeTotal"></vs-input>
                                <span class="text-danger text-sm">{{ errors.first('deduction') }}</span>
                            </vs-td>
                            <vs-td></vs-td>
                        </vs-tr>
                        <vs-tr>
                            <vs-td colspan="5">
                                <h5>Tổng tiền thanh toán</h5>
                            </vs-td>
                            <vs-td>
                                <vs-input v-model="receiptsInfo.amount" readonly></vs-input>
                            </vs-td>
                            <vs-td></vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
        </div>
        <vs-divider/>
        <div class="vx-row mt-4 mb-10">
            <div class="vx-col md:w-1/3 w-full mt-2">
                <label class="vs-input--label required">{{ $t('invoice.paid') }}</label>
                <vs-input class="w-full" v-model="receiptsInfo.paid" v-validate="'required|numeric'"
                          name="paid" @input="checkMoney"></vs-input>
                <span class="text-danger text-sm">{{ errors.first('paid') }}</span>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-2">
                <label class="vs-input--label required">{{ $t('invoice.status') }}</label>
                <v-select class="w-full" v-model="receiptsInfo.status" :options="statusOptions"
                          :reduce="(option) => option.value" :clearable="false" disabled
                          name="status">
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('status') }}</span>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-2">
                <label class="vs-input--label">{{ $t('invoice.collector') }}</label>
                <v-select class="w-full" v-model="receiptsInfo.collector" :options="collectorOptions"
                          :reduce="(option) => option.value" :clearable="false" v-validate="''"
                          name="collector">
                    <span slot="no-options">{{ $t('root.noRowsToShow') }}</span>
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('collector') }}</span>
            </div>
            <div class="vx-col w-full mt-2">
                <label class="vs-input--label">{{ $t('invoice.note') }}</label>
                <vs-textarea class="w-full" v-model="receiptsInfo.note"></vs-textarea>
            </div>
        </div>
        <div class="vx-row mt-8">
            <div class="vx-col w-full flex justify-end">
                <vs-button class="mr-2" @click="saveChanges" :disabled="!validateForm">
                    {{ `${isUpdate ? $t('button.update') : $t('button.create')}` }}
                </vs-button>
                <vs-button class="ml-4" type="border" color="warning" @click="$router.go(-1)" v-if="!isUpdate">
                    {{ $t('button.back') }}
                </vs-button>
                <vs-button class="ml-4" type="border" color="danger" @click="closePopup" v-else>
                    {{ $t('button.close') }}
                </vs-button>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import {vi} from 'vuejs-datepicker/dist/locale';

export default {
    name: "ReceiptsDetails",
    components: {
        vSelect,
        Datepicker,
    },
    props: {
        receiptsId: {
            default: null,
            type: Number
        }
    },
    data() {
        return {
            receiptsInfo: {
                organizationBranchId: null,
                studentId: 'null',
                classId: null,
                billCode: null,
                paymentDate: new Date(),
                type: null,
                status: null,
                qrCodeBillId: null,
                paid: 0,
                amount: null,
                collector: null,
                html: null,
                tuitionBillDetails: [],
                deduction: 0,
                displayMoney: null,
                note: null,
                dueDate: null,
            },
            highlighted: {
                dates: [
                    new Date()
                ]
            },
            disabledFn: {
                customPredictor(date) {
                    if (moment(date).isAfter(moment(), 'days')) {
                        return true;
                    }
                }
            },
            vi: vi,
            typeOptions: [
                {value: 0, label: this.$t('invoice.student')},
                {value: 1, label: this.$t('invoice.school')},
            ],
            branchOptions: [],
            classOptions: [],
            studentOptions: [],
            statusOptions: [
                {value: 0, label: this.$t('invoice.haventPaidYet')},
                {value: 1, label: this.$t('invoice.paid')},
                {value: 2, label: this.$t('invoice.paying')},
            ],
            collectorOptions: [],
            isUpdate: false,
            indexDelete: 0,
            listDetails: [{
                product: null,
                unit: null,
                quantity: null,
                unitPrice: null,
                amount: null,
            }],
            optionsNumber: {
                number: {
                    numeral: true,
                    numeralThousandsGroupStyle: 'thousand',
                },
            },

        }
    },

    computed: {
        validateForm() {
            return !this.errors.any()
        },
    },

    async created() {
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.filter(x => x.organizationBranchType === 3).map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });

        await this.getCollector();
        if (this.receiptsId) {
            this.isUpdate = true;
            await this.getDetailsReceipts();
            if (this.receiptsInfo.classId) {
                await this.getClassBySchool();
                if (this.receiptsInfo.studentId) {
                    await this.getStudentByClass();
                }
            }
        }
    },

    methods: {
        async changeType() {
            this.receiptsInfo.classId = null;
            this.receiptsInfo.studentId = 'null';
            if (this.receiptsInfo.type === 0 && this.receiptsInfo.organizationBranchId) {
                await this.getClassBySchool();
            }
        },

        getClassBySchool() {
            return new Promise((resolve, reject) => {
                let payload = {
                    organizationBranchId: this.receiptsInfo.organizationBranchId,
                    pageNumber: 0,
                    pageSize: 1000,
                }
                this.classOptions = [];
                this.$vs.loading();
                this.$crm.post('/school-classroom/find-by-condition', payload).then(res => {
                    this.$vs.loading.close();
                    resolve(res);
                    if (res.data.content && res.data.content.length > 0) {
                        this.classOptions = res.data.content.map(el => {
                            return {
                                value: el.id,
                                label: el.className,
                            }
                        })
                    }
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        async changeClass() {
            this.receiptsInfo.studentId = 'null';
            await this.getStudentByClass();
        },

        getStudentByClass() {
            return new Promise((resolve, reject) => {
                let payload = {
                    organizationBranchId: this.receiptsInfo.organizationBranchId,
                    classId: this.receiptsInfo.classId,
                    pageNumber: 1,
                    pageSize: 100,
                }
                this.studentOptions = [];
                this.$vs.loading();
                this.$crm.post('/school-student/search', payload).then(res => {
                    this.$vs.loading.close();
                    resolve(res);
                    if (res.data.content && res.data.content.length > 0) {
                        this.studentOptions = res.data.content.map(el => {
                            return {
                                value: el.id,
                                label: el.fullName,
                            }
                        })
                    }
                    this.studentOptions.unshift({value: 'null', label: 'Tất cả'})
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getCollector() {
            return new Promise((resolve, reject) => {
                let payload = {
                    departmentId: null,
                    enabled: true,
                }

                this.$vs.loading();
                this.$crm.post('/employee/all', payload).then(res => {
                    this.$vs.loading.close();
                    if (res.data && res.data.length > 0) {
                        this.collectorOptions = res.data.map(el => {
                            return {
                                value: el.employeeId,
                                label: el.fullName,
                            }
                        })
                    } else {
                        this.collectorOptions = [];
                    }
                    resolve(res);
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        addRecord() {
            this.listDetails.push({
                product: null,
                unit: null,
                quantity: null,
                unitPrice: null,
                amount: null,
            })
        },

        confirmDeleteRecord(ind) {
            this.indexDelete = ind;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá hàng ${ind + 1} không ?`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },

        deleteRecord() {
            this.listDetails.splice(this.indexDelete, 1)
        },

        async saveChanges(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;

            const result = await this.$validator.validateAll();
            if (!result) return;

            this.listDetails.forEach(el => {
                if (!el.product || !el.unit || isNaN(el.quantity) || isNaN(el.unitPrice)) {
                    el['check'] = false;
                } else {
                    el['check'] = true;
                }
            })

            let check = this.listDetails.filter(el => !el.check)
            if (check.length > 0) {
                return this.$vs.notify({
                    text: 'Hãy điền đầy đủ các trường bắt buộc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            await this.checkMoney();
            await this.selectDate();

            this.receiptsInfo.tuitionBillDetails = this.listDetails;

            let payload = this.receiptsInfo
            payload.studentId = JSON.parse(this.receiptsInfo.studentId)
            if (this.isUpdate) delete this.receiptsInfo.schoolTuitionBillDetailList;
            let url = this.isUpdate ? '/tuition-bill/update' : '/tuition-bill/create';

            this.$vs.loading();
            this.$crm.post(url, this.receiptsInfo).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: `${this.isUpdate ? 'Cập nhật' : 'Tạo mới'} phiếu thu thành công!`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                if (!this.isUpdate) {
                    this.$router.push('/user/manage-receipts').catch(() => {
                    })
                } else {
                    this.closePopup();
                    this.$store.commit('UPDATE_RECEIPTS', true);
                }
                this.$router.push('/user/manage-receipts').catch(() => {
                })
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        charge(data) {
            if (data.quantity && !isNaN(data.quantity) && !isNaN(data.unitPrice) && parseFloat(data.unitPrice) >= 0) {
                data.amount = parseInt(data.quantity, 10) * parseInt(data.unitPrice, 10)
            } else (
                data.amount = null
            )
            this.chargeTotal();
        },

        chargeTotal() {
            let money = [];
            this.listDetails.forEach(el => {
                if (parseFloat(el.unitPrice) >= 0) money.push(el.amount);
            })
            if (money.length > 0) this.receiptsInfo.amount = money.reduce((partialSum, a) => partialSum + a, 0) - this.receiptsInfo.deduction;
            if (parseFloat(this.receiptsInfo.amount) < 0) {
                return this.$vs.notify({
                    text: 'Số tiền giảm trừ không được lớn hơn tổng tiền thanh toán!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.checkMoney();
        },

        checkMoney() {
            return new Promise((resolve, reject) => {
                if (this.receiptsInfo.amount == 0) {
                    this.receiptsInfo.paid = 0;
                    this.receiptsInfo.status = 1;
                    resolve();
                }
                if (parseFloat(this.receiptsInfo.amount) > 0) {
                    if (parseFloat(this.receiptsInfo.paid) == 0) {
                        this.receiptsInfo.status = 0;
                        resolve();
                    }
                    if (parseFloat(this.receiptsInfo.paid) === parseFloat(this.receiptsInfo.amount)) {
                        this.receiptsInfo.status = 1;
                        resolve();
                    }
                    if ((parseFloat(this.receiptsInfo.paid)) > 0 && (parseFloat(this.receiptsInfo.paid) < parseFloat(this.receiptsInfo.amount))) {
                        this.receiptsInfo.status = 2;
                        resolve();
                    }
                    if (parseFloat(this.receiptsInfo.paid) > parseFloat(this.receiptsInfo.amount)) {
                        reject();
                        return this.$vs.notify({
                            text: 'Số tiền đã đóng không được lớn hơn tổng tiền thanh toán!',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        });
                    }
                }
            })
        },

        selectDate() {
            return new Promise((resolve, reject) => {
                if (this.receiptsInfo.dueDate && this.receiptsInfo.paymentDate) {
                    let due = new Date(this.receiptsInfo.dueDate).getTime(),
                        payment = new Date(this.receiptsInfo.paymentDate).getTime();
                    if (payment > due) {
                        reject();
                        return this.$vs.notify({
                            text: 'Ngày thanh toán không được vượt quá hạn thanh toán!',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        });
                    }
                    resolve();
                }
            })
        },

        getDetailsReceipts() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post(`/tuition-bill/find-by-id/${this.receiptsId}`).then(res => {
                    this.$vs.loading.close();
                    this.receiptsInfo = res.data;
                    this.receiptsInfo.studentId = this.receiptsInfo.studentId ? this.receiptsInfo.studentId : 'null'
                    this.listDetails = res.data.schoolTuitionBillDetailList.map(el => {
                        delete el.id;
                        return el;
                    });
                    resolve();
                }).catch((err) => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        closePopup() {
            this.$eventBus.$emit("close-popup-details-receipts", {});
        }
    }
}
</script>

<style scoped>
.required:after {
    content: " *";
    color: red;
}
</style>

<style lang="scss">
.con-vs-dialog {
    z-index: 55000;
}
</style>
